module.exports = __webpack_public_path__ + "static/media/lift.6206b2b1.png";